import { render, staticRenderFns } from "./resizer.vue?vue&type=template&id=4f478589&scoped=true"
import script from "./resizer.vue?vue&type=script&lang=js"
export * from "./resizer.vue?vue&type=script&lang=js"
import style0 from "./resizer.vue?vue&type=style&index=0&id=4f478589&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f478589",
  null
  
)

export default component.exports